// Module
var code = "<div class=\"col-xs-4\"> <label class=\"control-label\"></label> <div class=\"form-control-static\">VOID</div> </div> ";
// Exports
export default code;